import { Stack, Typography } from "@mui/material";

import { HubIcon } from "../../components";
import {
  SectionBody,
  SectionCard,
  SectionHeader,
  SectionHeaderIcon,
  SubHeader,
} from "./styles";

export const BilingualTitle = ({ label, spanishLabel, size = "lg" }) => {
  const fontSize = size === "lg" ? 14 : 11;
  const subFontSize = size === "lg" ? 12 : 10;
  return (
    <Stack gap="2px">
      <Typography sx={{ fontWeight: 600, fontSize }}>{label}</Typography>
      {spanishLabel && (
        <Typography
          sx={{ fontWeight: 500, fontSize: subFontSize, color: "text.secondary" }}
        >
          {spanishLabel}
        </Typography>
      )}
    </Stack>
  );
};

export const Section = ({ icon, label, spanishLabel, children }) => (
  <SectionCard>
    <SectionHeader>
      {icon && (
        <SectionHeaderIcon>
          <HubIcon icon={icon} size={16} />
        </SectionHeaderIcon>
      )}
      <BilingualTitle label={label} spanishLabel={spanishLabel} />
    </SectionHeader>
    <SectionBody>{children}</SectionBody>
  </SectionCard>
);

export const SectionSubHeader = ({ label, spanishLabel }) => (
  <SubHeader>
    <BilingualTitle label={label} spanishLabel={spanishLabel} size="sm" />
  </SubHeader>
);
